/**
 * The single field a renderer switches on. Decides the SHAPE of the card body,
 * not what the thing is -- "lamp vs pump" is already carried entirely by `icon`.
 */
export enum Widget {
  READOUT = "READOUT", // 1..n numeric reads      (temperature, battery)
  GAUGE = "GAUGE", // vertical fill bar 0..100%   (water tank)
  SLIDER = "SLIDER", // range input, debounced    (dimmers, fan)
  BUTTONS = "BUTTONS", // preset value buttons    (lamp, pumps)
  COLOR = "COLOR", // rgb triple                  (tumblers)
  AC = "AC", // compound: 2 reads + target + fan + swing
  NONE = "NONE", // no body; inputs[] only        (settings card)
}

/** Semantic tag only. Never switch a renderer on this -- use Widget. */
export enum NodeType {
  LAMP = "LAMP",
  TEMPERATURE = "TEMPERATURE",
  AC = "AC",
  PUMP = "PUMP",
  THUMBLER = "THUMBLER",
  TANK = "TANK",
  BATTERY = "BATTERY",
  FAN = "FAN",
  SETTINGS = "SETTINGS",
  OTHER = "OTHER",
}

/**
 * What a /sources row IS. Not a policy flag: an engine is one ESP board that
 * streams its own tree and acts on it; telemetry is the shared aggregate every
 * board writes into and only the web app reads.
 */
export enum SourceKind {
  ENGINE = "engine",
  TELEMETRY = "telemetry",
}
